import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import colors from "theme/colors";
import { NewText } from "ui";
import { getUmbracoMediaUrl } from "utils/utils";

const StyledVideoBoxWrapper = styled.div`
  text-align: center; 
  display: flex;
  flex-direction: column;
  align-items: start;
  height: 100%;
  gap: 20px;

  ${(props) => props.theme.breakpoints.up("md")} {
    justify-content: space-between;
    gap: 30px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    width: 285px;
    gap: 50px;
  }


`
const StyledVideoWrapper = styled.div`
video {
  border-radius: 20px;
}
    width: 200px;
    height: 355px;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 175px;
    height: 316px ;
  }
      ${(props) => props.theme.breakpoints.up("lg")} {
        width: 285px;
    height: 508px;
  }
`
const StyledTitleAndTextWrapper = styled.div`
text-align: left;
`

const StyledContainer = styled.div`
  flex: 1 1 0;
  display: flex;

  gap: 30px;
    ${(props) => props.theme.breakpoints.up("md")} {
//   height: 550px;
//   justify-content: space-between;
  flex-direction: column;
  }
`
const StyledLine = styled.div`
  border-top: 1px dashed black;
  width: 100%;
  height: 0;

${(props) => props.theme.breakpoints.down("md")} {
    border-left: 1px dashed black;
  width: 0;
  height: 100%;
  }
`

const StyledNumberWithLine = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

${(props) => props.theme.breakpoints.down("md")} {
   flex-direction: column;
   margin-top: -50px;
  }
`



type Props = {
  url: string
  title: string,
  text: string,
  isPlaying: boolean,
  index: number,
  onEndVideo: () => void,

}
function VideoBoxCharge({ title, text, isPlaying, url, index, onEndVideo }: Props) {

  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (isPlaying && videoRef.current) {
      videoRef.current.play().catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Failed to play video:", error);
      });
    }
  }, [isPlaying]);

  useEffect(() => {
    const playVideo = () => {
      if (isPlaying && videoRef.current) {
        videoRef.current.play().catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Failed to play video:", error);
        });
      }
    }
    const video = videoRef.current;
    if (video) {
      video.load();
      video.addEventListener('canplay', playVideo);
    }
    return () => {
      if (video) {
        video.removeEventListener('canplay', playVideo);
      }
    };
  }, []);

  return (
    <StyledContainer>
      <StyledNumberWithLine>
        <NewText
          component={"span"}
          largeDesktopFontSize={48}
          largeDesktopLineHeight="50px"
          desktopFontSize={48}
          desktopLineHeight={"50px"}
          desktopFontWeight={500}
          mobileFontSize={64}
          mobileLineHeight={"75 px"}
          mobileFontWeight={500}
          color={colors.black}
        >
          {index}
        </NewText>
        <StyledLine />
      </StyledNumberWithLine>

      <StyledVideoBoxWrapper>
        <StyledTitleAndTextWrapper>
          <NewText
            component={"h3"}
            largeDesktopFontSize={34}
            largeDesktopLineHeight="36px"
            desktopFontSize={34}
            desktopLineHeight={"36px"}
            desktopFontWeight={500}
            mobileFontSize={24}
            mobileLineHeight={"28px"}
            mobileFontWeight={500}
            color={colors.black}
            style={{ display: "block", paddingBottom: 10 }}
          >
            {title}
          </NewText>
          <NewText
            component={"p"}
            largeDesktopFontSize={18}
            largeDesktopLineHeight="20px"
            desktopFontSize={18}
            desktopLineHeight={"20px"}
            desktopFontWeight={400}
            mobileFontSize={16}
            mobileLineHeight={"18px"}
            mobileFontWeight={400}
            color={"black"}
          >
            {text}
          </NewText>
        </StyledTitleAndTextWrapper>
        <StyledVideoWrapper>
          <video
            ref={videoRef}
            playsInline
            muted
            width="100%"
            height="100%"
            onEnded={onEndVideo}
            preload="auto"

          >
            <source src={getUmbracoMediaUrl(url)} type="video/mp4" />
          </video>
        </StyledVideoWrapper >
      </StyledVideoBoxWrapper>
    </StyledContainer>
  )
}

export default VideoBoxCharge
